import request from './request';
import url from './url';
import { LocalStorage } from '~/helpers';

const getHeaders = () => ({
  Authorization: `Bearer ${LocalStorage.getToken()}`,
  'Cache-Control': 'no-cache',
});

const getScenarios = () =>
  request(url.scenarios, {
    method: 'GET',
    headers: getHeaders(),
  });

export { getScenarios };
